"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = setCookiesParam;
var _CookiesStore = _interopRequireDefault(require("Components/Stores/CookiesStore"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function setCookiesParam(code, {
  id
}) {
  _CookiesStore.default.update(function (store) {
    store['param_' + code + '_id'] = id;
  });
}
